import { Icon } from "@backpac/monica";

export const DiffRatioDisplay = ({ diffRatio }: { diffRatio: number }) => {
  if (diffRatio === 0) {
    return <div className="text-sm font-semibold text-textMuted">0%</div>;
  }

  if (diffRatio > 0) {
    return (
      <div className="flex items-center gap-1.5 text-sm font-semibold text-colorGreenDark">
        <Icon name="increase" iconColor="colorGreenDark" className="size-3" />
        {Math.abs(diffRatio).toFixed(1)}%
      </div>
    );
  }
};
